export default String.raw`
.formal-content {
    margin: 30px 9%;

    .content {
        margin-bottom: 32px;

        &__header {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            margin-top: 24px;
            margin-bottom: 32px;
            gap: 16px;

            .date {
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                color: $dateOfPublication;
            }
        }

        ol {
            li {
                padding: 4px 0;
            }
        }

        ul {
            list-style-type: initial;
        }
    }

    .files {
        margin-bottom: 32px;
        display: flex;
        flex-direction: column;

        &__title {
            font-size: 18px;
            height: 24px;
            font-weight: 600;
            line-height: 24px;
            margin-bottom: 16px;
        }

        a {
            display: flex;
            align-items: center;
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            width: fit-content;
            gap: 4px;
            
            & + a {
                margin-top: 16px;
            }

            .file-icon {
                width: 24px;
                height: 24px;
                display: inline-block;
                fill: $primaryColor;
            }
        }
    }
}
`